class OrderHistoryController {
    /*@ngInject*/
    constructor($log, $http, $rootScope, CommonService) {
        $log.debug('OrderHistoryController initialized');
        this.$log = $log;
        this.$http = $http;
        this.commonService = CommonService;
    }

    showDetail(posTrxId) {
        if (posTrxId === '') {
            this.$log.error('The order number is empty, order details request cannot be sent');
            return;
        }

        window.location.href = this.commonService.getBaseUrl() + '/account/order/' + posTrxId;
    }
}

export default OrderHistoryController;
